import { Component, OnInit } from '@angular/core';
import { ClaimService } from './claim.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  templateUrl: './claim.component.html',
  providers: [ClaimService]
})
export class ClaimComponent implements OnInit {
  public iframeBodySRC = '';
  public token: string | null;
  public jwtHelperService: JwtHelperService = new JwtHelperService();
  private user: any;
  private MOTO_BRANCH = 'moto';

  constructor(private claimService: ClaimService, private route: ActivatedRoute, private router: Router) {
    this.setClaimLink();
  }

  ngOnInit() {
    this.token = localStorage.getItem('tk');
    this.user = this.token && this.jwtHelperService.decodeToken(this.token);
    if (this.token) {
      const reset = localStorage.getItem('reset');
      if (reset) {
        localStorage.removeItem('reset');
      }
    }
  }

  setClaimLink() {
    this.route.queryParams.subscribe((params) => {
      const claimDetailNumber = params['detalle'];
      const branch = params['branch'];
      this.claimService.check().subscribe((result) => {
        if (result) {
          const linkSplit = result.link.split('?');
          let formattedUrl = '';
          if (claimDetailNumber) {
            formattedUrl = claimDetailNumber ? '/detalle/' + claimDetailNumber : '';
            const branchQueryParam = params.branch === this.MOTO_BRANCH ? '&branch=motorcycle' : '';
            this.iframeBodySRC = linkSplit[0] + formattedUrl + '?' + linkSplit[1] + branchQueryParam;
          } else if (branch) {
            formattedUrl = branch ? '&branch=' + branch : '';
            this.iframeBodySRC = result.link + formattedUrl;
          } else {
            this.iframeBodySRC = result.link;
          }
        } else {
          this.iframeBodySRC = '';
        }
      });
    });
  }
}
